/** @jsx jsx */
import { jsx } from 'theme-ui'
import { ItemList, WithContext } from 'schema-dts'
import { useStaticQuery, graphql } from 'gatsby'
import { FC, Fragment } from 'react'
import { ProductItemComponentType } from '~/@types/models'
import urls from '~/common/urls'
import { SiteMetadataQueryType } from '~/common/queries'

interface Props {
  data: readonly ProductItemComponentType[]
}

type QueryResult = Pick<SiteMetadataQueryType, 'site'>

const collectionRichSnippetQuery = graphql`
  query collectionRichSnippetQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

const CollectionRichSnippet = ({ data }: Props) => {
  const {
    site: {
      siteMetadata: { siteUrl },
    },
  } = useStaticQuery<QueryResult>(collectionRichSnippetQuery)

  if (!data?.length) return null

  const hiddenTitles = data.map(product => (
    <h3 sx={{ display: 'none' }} key={product.id}>
      {product.title}
    </h3>
  ))

  const collectionData: WithContext<ItemList> = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: data.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      url: `${siteUrl}${urls.pages.productDetail}/${product.handle}`,
    })),
  }

  return (
    <div style={{ display: 'contents' }} className="collection-rich-snippet">
      {hiddenTitles}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(collectionData),
        }}
      />
    </div>
  )
}

export default CollectionRichSnippet
